import { render } from "./MedicalInfoView.vue?vue&type=template&id=69287a96&scoped=true"
import script from "./MedicalInfoView.vue?vue&type=script&lang=js"
export * from "./MedicalInfoView.vue?vue&type=script&lang=js"

import "./MedicalInfoView.vue?vue&type=style&index=0&id=69287a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69287a96"]])

export default __exports__